import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router'
import { Layout } from '@/components/custom/layout'
import ChatList from '@/components/chat-route/chat-list'
import useChatStore from '@/store/chat-store.js'
import { useEffect } from 'react'
import { Card, CardContent } from '@/components/ui/card'
import { navigateGuard } from '@/utils/auth.js'
import { UserRole } from '@/constants/user.js'
import ChatboxPlaceholder from '@/assets/images/chatbox-placeholder.webp'

export const Route = createFileRoute('/_auth/chat')({
  beforeLoad: ({ location }) =>
    navigateGuard(location, [
      UserRole.ADMINISTRATOR,
      UserRole.SUPERVISOR,
      UserRole.AGENT,
    ]),
  component: Chat,
})

function Chat() {
  const { ticketId } = Route.useParams()
  const navigate = useNavigate()
  const currentChatId = useChatStore((state) => state.currentChatId)
  const setCurrentChatId = useChatStore((state) => state.setCurrentChatId)

  useEffect(() => {
    if (!currentChatId) {
      setCurrentChatId(ticketId)
      return
    }

    navigate({
      to: '/chat/$ticketId',
      params: { ticketId: currentChatId },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Layout.Body>
      <Card className="m-0 p-0">
        <CardContent className="flex h-[calc(100vh-var(--header-height)-var(--body-padding-y)*2)] gap-0 p-0">
          <div className="h-full w-[380px] min-w-[380px]">
            <ChatList />
          </div>
          <div className="h-full flex-1">
            {ticketId ? (
              <Outlet />
            ) : (
              <div className="flex h-full w-full flex-col items-center justify-center">
                <img src={ChatboxPlaceholder} alt="chatbox-placeholder" />
                <span className="mt-6 text-muted-foreground">
                  Trải nghiệm kết nối hội thoại đa kênh cùng ZENIFY
                </span>
              </div>
            )}
          </div>
        </CardContent>
      </Card>
    </Layout.Body>
  )
}
